// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.deploy-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
}

.deploy-header {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e0e0e0;
}

.header-info h1 {
  margin: 0;
  font-size: 2rem;
  font-weight: 600;
  color: #1a1a1a;
}

.project-title {
  margin: 5px 0 0 0;
  color: #666;
  font-size: 1rem;
}

.back-button {
  background: none;
  border: 1px solid #ddd;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  color: #555;
  transition: all 0.2s ease;
}

.back-button:hover {
  background-color: #f5f5f5;
  border-color: #bbb;
}

.deploy-button {
  background-color: #28a745;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  margin-left: 10px;
}

.deploy-button:hover {
  background-color: #218838;
  transform: translateY(-1px);
}

.loading {
  text-align: center;
  padding: 40px;
  color: #666;
  font-size: 1.1rem;
}

.error-message {
  text-align: center;
  padding: 40px;
  color: #dc3545;
}

.retry-button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 10px;
}

.retry-button:hover {
  background-color: #0056b3;
}

.no-videos {
  text-align: center;
  padding: 60px 20px;
  color: #666;
}

.no-videos-icon {
  font-size: 4rem;
  margin-bottom: 20px;
}

.no-videos h3 {
  margin: 0 0 15px 0;
  font-size: 1.5rem;
  color: #333;
}

.no-videos p {
  margin: 5px 0;
  font-size: 1rem;
}

.videos-list {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.video-row {
  display: flex;
  gap: 20px;
  padding: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  background: white;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  align-items: flex-start;
}

.video-row:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  border-color: #d0d0d0;
}

.video-preview-section {
  flex: 0 0 320px;
}

.video-player-container {
  margin: 10px 0;
}

.video-player {
  width: 100%;
  height: 180px;
  border-radius: 8px;
  background: #000;
}

.video-content-section {
  flex: 1 1;
  min-height: 100px;
  padding: 0 20px;
}

.youtube-content h4 {
  margin: 0 0 15px 0;
  font-size: 1rem;
  font-weight: 600;
  color: #1a1a1a;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 8px;
}

.youtube-form .form-group {
  margin-bottom: 15px;
}

.youtube-form label {
  display: block;
  margin-bottom: 5px;
  font-size: 0.85rem;
  font-weight: 500;
  color: #555;
}

.youtube-input,
.youtube-textarea {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 0.9rem;
  font-family: inherit;
  transition: border-color 0.2s ease;
  box-sizing: border-box;
}

.youtube-input:focus,
.youtube-textarea:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
}

.youtube-textarea {
  resize: vertical;
  min-height: 120px;
}

.youtube-placeholder {
  text-align: center;
  padding: 30px 20px;
  color: #666;
}

.youtube-placeholder p {
  margin: 5px 0;
  font-size: 0.9rem;
}

.published-video-info {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  background-color: #f8fff9;
  border: 1px solid #28a745;
  border-radius: 6px;
}

.published-video-link {
  color: #dc3545;
  text-decoration: none;
  font-weight: 500;
  font-size: 0.9rem;
}

.published-video-link:hover {
  text-decoration: underline;
}

.published-status {
  color: #28a745;
  font-size: 0.8rem;
  font-weight: 500;
}

.generate-yt-button {
  background-color: #17a2b8;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.generate-yt-button:hover {
  background-color: #138496;
  transform: translateY(-1px);
}

.generate-yt-button:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
  transform: none;
}

.refresh-videos-button {
  background-color: #6f42c1;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.refresh-videos-button:hover {
  background-color: #5a32a3;
  transform: translateY(-1px);
}

.refresh-videos-button:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
  transform: none;
}

.video-actions {
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid #eee;
}

.analyze-individual-audio-button {
  background-color: #28a745;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.analyze-individual-audio-button:hover:not(:disabled) {
  background-color: #218838;
  transform: translateY(-1px);
}

.analyze-individual-audio-button:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
  transform: none;
  opacity: 0.6;
}

.loading-spinner {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.audio-quality-section {
  display: flex;
  align-items: center;
  gap: 15px;
  flex-wrap: wrap;
}

.audio-quality-status {
  display: flex;
  align-items: center;
  gap: 8px;
}

.quality-indicator {
  background: none;
  border: 2px solid;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.quality-indicator:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.quality-good {
  color: #28a745;
  border-color: #28a745;
  background-color: rgba(40, 167, 69, 0.1);
}

.quality-good:hover {
  background-color: rgba(40, 167, 69, 0.2);
}

.quality-fair {
  color: #ffc107;
  border-color: #ffc107;
  background-color: rgba(255, 193, 7, 0.1);
}

.quality-fair:hover {
  background-color: rgba(255, 193, 7, 0.2);
}

.quality-poor {
  color: #dc3545;
  border-color: #dc3545;
  background-color: rgba(220, 53, 69, 0.1);
}

.quality-poor:hover {
  background-color: rgba(220, 53, 69, 0.2);
}

.quality-error {
  color: #6c757d;
  border-color: #6c757d;
  background-color: rgba(108, 117, 125, 0.1);
}

.quality-error:hover {
  background-color: rgba(108, 117, 125, 0.2);
}

.quality-date {
  font-size: 11px;
  color: #666;
  font-style: italic;
}

.youtube-content-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.youtube-content-header h4 {
  margin: 0;
}

.publish-toggle-container {
  display: flex;
  align-items: center;
}

.publish-toggle {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.toggle-checkbox {
  display: none;
}

.toggle-slider {
  position: relative;
  width: 50px;
  height: 24px;
  background-color: #ccc;
  border-radius: 12px;
  transition: background-color 0.3s ease;
}

.toggle-slider:before {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
  background-color: white;
  border-radius: 50%;
  transition: transform 0.3s ease;
}

.toggle-checkbox:checked + .toggle-slider {
  background-color: #28a745;
}

.toggle-checkbox:checked + .toggle-slider:before {
  transform: translateX(26px);
}

.toggle-label {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.toggle-checkbox:checked ~ .toggle-label {
  color: #28a745;
}

.header-buttons {
  display: flex;
  gap: 10px;
  align-items: center;
}

.prepare-deploy-button {
  background-color: #ffc107;
  color: #212529;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.prepare-deploy-button:hover {
  background-color: #e0a800;
  transform: translateY(-1px);
}

.prepare-deploy-button:disabled {
  background-color: #6c757d;
  color: white;
  cursor: not-allowed;
  transform: none;
}

.publish-button {
  background-color: #28a745;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.publish-button:hover {
  background-color: #218838;
  transform: translateY(-1px);
}

.publish-button:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
  transform: none;
}

.thumbnail-upload {
  margin-bottom: 20px;
  padding: 15px;
  border: 2px dashed #ddd;
  border-radius: 8px;
  background-color: #f8f9fa;
}

.thumbnail-upload label {
  display: block;
  margin-bottom: 8px;
  font-size: 0.9rem;
  font-weight: 500;
  color: #333;
}

.thumbnail-input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.9rem;
  background-color: white;
}

.thumbnail-preview {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
  padding: 10px;
  background-color: white;
  border-radius: 6px;
  border: 1px solid #e0e0e0;
}

.thumbnail-image {
  width: 80px;
  height: 45px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #ddd;
}

.thumbnail-status {
  color: #28a745;
  font-size: 0.85rem;
  font-weight: 500;
}

/* Deployment Results Styles */
.deployment-results {
  margin: 20px 0;
  padding: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #f8f9fa;
}

.results-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e0e0e0;
}

.results-header h3 {
  margin: 0;
  color: #333;
  font-size: 1.1rem;
}

.results-summary {
  display: flex;
  gap: 15px;
}

.success-count {
  color: #28a745;
  font-weight: 500;
  font-size: 0.9rem;
}

.error-count {
  color: #dc3545;
  font-weight: 500;
  font-size: 0.9rem;
}

.success-message {
  text-align: center;
  padding: 20px;
  color: #28a745;
  font-size: 1.1rem;
  font-weight: 500;
}

.results-details {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.result-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  border-radius: 6px;
  background-color: white;
  border: 1px solid #e0e0e0;
}

.result-item.success {
  border-left: 4px solid #28a745;
  background-color: #f8fff9;
}

.result-item.failed {
  border-left: 4px solid #dc3545;
  background-color: #fff8f8;
}

.result-language {
  font-weight: 500;
  color: #333;
}

.result-status .success {
  color: #28a745;
  font-weight: 500;
}

.result-status .failed {
  color: #dc3545;
  font-weight: 500;
}

.video-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.video-id {
  font-size: 0.8rem;
  color: #666;
  font-family: monospace;
}

.video-link {
  font-size: 0.8rem;
  color: #007bff;
  text-decoration: none;
  font-weight: 500;
}

.video-link:hover {
  text-decoration: underline;
}

/* Deployment Errors Styles */
.deployment-errors {
  margin: 20px 0;
  padding: 20px;
  border: 2px solid #dc3545;
  border-radius: 8px;
  background-color: #fff5f5;
}

.error-header {
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f5c6cb;
}

.error-header h3 {
  margin: 0;
  color: #721c24;
  font-size: 1.1rem;
}

.error-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 15px;
}

.error-item {
  padding: 12px 15px;
  border-radius: 6px;
  background-color: white;
  border: 1px solid #f5c6cb;
  border-left: 4px solid #dc3545;
}

.error-language {
  font-weight: 500;
  color: #721c24;
  margin-bottom: 5px;
}

.error-message {
  color: #856404;
  font-size: 0.9rem;
  line-height: 1.4;
  background-color: #fff3cd;
  padding: 8px 10px;
  border-radius: 4px;
  border: 1px solid #ffeaa7;
}

.error-actions {
  text-align: right;
}

.dismiss-errors-btn {
  background-color: #6c757d;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background-color 0.2s ease;
}

.dismiss-errors-btn:hover {
  background-color: #5a6268;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #e0e0e0;
}

.modal-header h3 {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 600;
  color: #1a1a1a;
}

.modal-close {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s ease;
}

.modal-close:hover {
  background-color: #f5f5f5;
}

.modal-content {
  padding: 20px;
  max-height: 400px;
  overflow-y: auto;
}

.modal-content .form-group {
  margin-bottom: 20px;
}

.modal-content label {
  display: block;
  margin-bottom: 8px;
  font-size: 0.9rem;
  font-weight: 500;
  color: #333;
}

.modal-content input,
.modal-content textarea {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 0.9rem;
  font-family: inherit;
  transition: border-color 0.2s ease;
  box-sizing: border-box;
}

.modal-content input:focus,
.modal-content textarea:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 20px;
  border-top: 1px solid #e0e0e0;
}

.modal-cancel,
.modal-save {
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.modal-cancel {
  background: none;
  border: 1px solid #ddd;
  color: #555;
}

.modal-cancel:hover {
  background-color: #f5f5f5;
}

.modal-save {
  background-color: #28a745;
  border: none;
  color: white;
}

.modal-save:hover {
  background-color: #218838;
}

.modal-save:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

.language-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 0;
  text-align: left;
}

.language-header h3 {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: #1a1a1a;
}

.language-code {
  font-size: 0.8rem;
  color: #666;
  background: #f8f9fa;
  padding: 2px 6px;
  border-radius: 4px;
}

.video-metadata-compact {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  margin-top: 8px;
  padding: 6px 8px;
  background: #f8f9fa;
  border-radius: 6px;
  flex-wrap: wrap;
}

.video-metadata-compact .metadata-item {
  display: flex;
  align-items: center;
  gap: 3px;
  font-size: 0.75rem;
  color: #555;
  font-weight: 500;
}


.deploy-footer {
  text-align: center;
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px solid #e0e0e0;
}

.stats {
  color: #666;
  font-size: 0.9rem;
}

/* Responsive design */
@media (max-width: 768px) {
  .deploy-page {
    padding: 15px;
  }
  
  .video-row {
    flex-direction: column;
    gap: 15px;
  }
  
  .video-preview-section {
    flex: none;
    max-width: 100%;
  }
  
  .video-player {
    height: 200px;
  }
  
  .language-header h3 {
    font-size: 1rem;
  }
  
  .video-metadata-compact {
    justify-content: center;
    gap: 12px;
  }
  
  .deploy-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  
  .header-info h1 {
    font-size: 1.5rem;
  }
}

@media (max-width: 480px) {
  .video-preview-section {
    flex: none;
  }
  
  .video-player {
    height: 180px;
  }
  
  .language-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
  
  .video-metadata-compact {
    flex-direction: column;
    gap: 6px;
    align-items: flex-start;
  }
  
  .video-metadata-compact .metadata-item {
    font-size: 0.7rem;
  }
}

/* Audio Analysis Styles */
.analyze-audio-button {
  background-color: #6f42c1;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.analyze-audio-button:hover:not(:disabled) {
  background-color: #5a359a;
  transform: translateY(-1px);
}

.analyze-audio-button:disabled {
  background-color: #9c88c4;
  cursor: not-allowed;
  transform: none;
}

.audio-analysis-overlay {
  position: relative;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border: 2px solid #6f42c1;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 4px 12px rgba(111, 66, 193, 0.15);
}

.audio-analysis-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #dee2e6;
}

.audio-analysis-header h4 {
  margin: 0;
  color: #6f42c1;
  font-size: 1.1rem;
  font-weight: 600;
}

.close-analysis-btn {
  background: none;
  border: none;
  font-size: 24px;
  color: #6c757d;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.close-analysis-btn:hover {
  background-color: #e9ecef;
  color: #495057;
}

.audio-analysis-content {
  space: 16px 0;
}

.overall-status {
  margin-bottom: 16px;
}

.status-indicator {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 14px;
}

.status-indicator.good {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.status-indicator.fair {
  background-color: #fff3cd;
  color: #856404;
  border: 1px solid #ffeaa7;
}

.status-indicator.poor {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.status-indicator.error,
.status-indicator.unknown {
  background-color: #e2e3e5;
  color: #41464b;
  border: 1px solid #d6d8db;
}

.analysis-summary {
  margin-bottom: 16px;
  padding: 12px;
  background-color: #ffffff;
  border-radius: 8px;
  border-left: 4px solid #6f42c1;
}

.analysis-summary strong {
  color: #6f42c1;
  display: block;
  margin-bottom: 8px;
}

.analysis-summary p {
  margin: 0;
  color: #495057;
  line-height: 1.5;
}

.audio-issues {
  margin-bottom: 16px;
}

.audio-issues strong {
  color: #dc3545;
  display: block;
  margin-bottom: 12px;
  font-size: 16px;
}

.audio-issues ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.issue-item {
  background-color: #ffffff;
  border: 1px solid #f8d7da;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 8px;
  border-left: 4px solid #dc3545;
}

.issue-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  flex-wrap: wrap;
  gap: 8px;
}

.issue-type-badge {
  font-weight: 600;
  color: #721c24;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background-color: #f8d7da;
  padding: 4px 8px;
  border-radius: 4px;
  border: 1px solid #f5c6cb;
}

.issue-timestamp-precise {
  background-color: #495057;
  color: white;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 13px;
  font-family: 'SF Mono', 'Monaco', 'Menlo', monospace;
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;
}

.timestamp-seconds {
  font-size: 11px;
  opacity: 0.8;
  font-weight: 400;
}

.timeline-item-info {
  font-size: 10px;
  background-color: rgba(255, 255, 255, 0.2);
  padding: 2px 6px;
  border-radius: 3px;
  margin-left: 4px;
}

.issue-type {
  font-weight: 600;
  color: #721c24;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}

.issue-timestamp {
  background-color: #495057;
  color: white;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-family: monospace;
  display: inline-block;
  margin-bottom: 8px;
}

/* Save YouTube Details Button */
.save-youtube-btn {
  background: linear-gradient(135deg, #28a745, #20c997);
  color: white;
  border: none;
  padding: 10px 16px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  margin-top: 8px;
}

.save-youtube-btn:hover {
  background: linear-gradient(135deg, #218838, #1ea080);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(40, 167, 69, 0.3);
}

.save-youtube-btn:active {
  transform: translateY(0);
}

.save-youtube-btn:disabled {
  background: #6c757d;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* YouTube Actions Container */
.youtube-actions {
  display: flex;
  gap: 10px;
  align-items: center;
}

/* Remove YouTube Details Button */
.remove-youtube-btn {
  background: linear-gradient(135deg, #dc3545, #c82333);
  color: white;
  border: none;
  padding: 10px 16px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(220, 53, 69, 0.2);
}

.remove-youtube-btn:hover {
  background: linear-gradient(135deg, #c82333, #bd2130);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(220, 53, 69, 0.3);
}

.remove-youtube-btn:active {
  transform: translateY(0);
}

.remove-youtube-btn:disabled {
  background: #6c757d;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.analysis-info {
  margin-top: 12px;
  padding: 8px 12px;
  background-color: #f8f9fa;
  border-radius: 4px;
  border: 1px solid #dee2e6;
}

.analysis-info small {
  color: #6c757d;
  font-size: 12px;
}

.quality-breakdown {
  margin-top: 6px;
  padding-top: 6px;
  border-top: 1px solid #e9ecef;
  font-size: 11px;
}

.detailed-analysis {
  margin-top: 16px;
  padding: 16px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.detailed-analysis strong {
  display: block;
  margin-bottom: 12px;
  color: #495057;
  font-size: 14px;
}

.detailed-analysis-grid {
  display: grid;
  gap: 12px;
  max-height: 400px;
  overflow-y: auto;
}

.clip-analysis-item {
  background: white;
  padding: 12px;
  border-radius: 6px;
  border: 1px solid #dee2e6;
}

.clip-analysis-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.clip-id {
  font-weight: 600;
  color: #495057;
  font-size: 13px;
}

.clip-quality {
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
}

.clip-quality.good {
  background-color: #d4edda;
  color: #155724;
}

.clip-quality.fair {
  background-color: #fff3cd;
  color: #856404;
}

.clip-quality.poor {
  background-color: #f8d7da;
  color: #721c24;
}

.clip-quality.error {
  background-color: #f5c6cb;
  color: #721c24;
}

.clip-details {
  font-size: 12px;
  color: #6c757d;
}

.narration-preview {
  font-style: italic;
  margin-bottom: 6px;
  color: #495057;
}

.clip-issue {
  color: #dc3545;
  font-weight: 500;
  margin-bottom: 6px;
}

.clip-meta {
  font-size: 11px;
  color: #6c757d;
}

.text-mismatch {
  color: #856404;
  font-weight: 500;
}

.more-clips-notice {
  text-align: center;
  color: #6c757d;
  font-style: italic;
  padding: 12px;
  background-color: #e9ecef;
  border-radius: 4px;
}

.issue-description {
  color: #495057;
  line-height: 1.4;
  font-size: 14px;
}

.audio-recommendations {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 16px;
  border-left: 4px solid #28a745;
}

.audio-recommendations strong {
  color: #28a745;
  display: block;
  margin-bottom: 12px;
  font-size: 16px;
}

.audio-recommendations ul {
  margin: 0;
  padding-left: 20px;
}

.audio-recommendations li {
  color: #495057;
  line-height: 1.5;
  margin-bottom: 6px;
}

@media (max-width: 768px) {
  .audio-analysis-overlay {
    margin: 10px 0;
    padding: 16px;
  }
  
  .audio-analysis-header h4 {
    font-size: 1rem;
  }
  
  .issue-item {
    padding: 10px;
  }
}

/* Audio Analysis Loader */
.audio-analysis-loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.audio-analysis-loader {
  background: white;
  border-radius: 16px;
  padding: 40px;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  max-width: 400px;
  width: 90%;
}

.loader-spinner {
  width: 60px;
  height: 60px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #6f42c1;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 20px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.audio-analysis-loader h3 {
  margin: 0 0 16px 0;
  color: #6f42c1;
  font-size: 1.2rem;
  font-weight: 600;
}

.audio-analysis-loader p {
  margin: 8px 0 0 0;
  color: #666;
  font-size: 14px;
  line-height: 1.4;
}

/* Comprehensive Analysis Styles */
.comprehensive-analysis {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border: 2px solid #6f42c1;
  border-radius: 12px;
  padding: 24px;
  margin: 20px 0;
  box-shadow: 0 6px 16px rgba(111, 66, 193, 0.2);
}

.analysis-details {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.analysis-info-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 12px;
  font-weight: 500;
  color: #495057;
  margin-bottom: 16px;
}

.raw-analysis-content {
  background-color: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  line-height: 1.6;
  color: #333;
  max-height: 500px;
  overflow-y: auto;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.05);
}

.analysis-header {
  color: #6f42c1;
  font-weight: 600;
  font-size: 16px;
  margin: 16px 0 8px 0;
  padding-bottom: 4px;
  border-bottom: 2px solid #e9ecef;
}

.analysis-header:first-child {
  margin-top: 0;
}

.analysis-line {
  margin: 8px 0;
  color: #495057;
  font-size: 14px;
}

.analysis-line strong {
  color: #212529;
  font-weight: 600;
}

.analysis-line em {
  color: #6c757d;
  font-style: italic;
}

/* YT Generation Progress Overlay */
.generation-progress-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.generation-progress-modal {
  background: white;
  border-radius: 12px;
  padding: 30px;
  min-width: 400px;
  max-width: 500px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.progress-header h3 {
  margin: 0 0 20px 0;
  color: #333;
  text-align: center;
}

.progress-content {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.progress-step,
.progress-language {
  color: #666;
  font-size: 14px;
}

.progress-bar {
  width: 100%;
  height: 8px;
  background: #f0f0f0;
  border-radius: 4px;
  overflow: hidden;
}

.progress-bar-fill {
  height: 100%;
  background: linear-gradient(45deg, #007bff, #0056b3);
  transition: width 0.3s ease;
  border-radius: 4px;
}

.progress-text {
  text-align: center;
  color: #666;
  font-size: 14px;
}

@media (max-width: 768px) {
  .generation-progress-modal {
    width: 90%;
    min-width: unset;
    padding: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/DeployPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,gFAAgF;AAClF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,wCAAwC;EACxC,uBAAuB;AACzB;;AAEA;EACE,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,6BAA6B;AAC7B;EACE,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,aAAa;EACb,6BAA6B;AAC/B;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;;AAGA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,sBAAsB;IACtB,QAAQ;IACR,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,oDAAoD;EACpD,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,0CAA0C;EAC1C,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,gCAAgC;AAChC;EACE,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gFAAgF;EAChF,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;IACV,gBAAgB;IAChB,aAAa;EACf;AACF","sourcesContent":[".deploy-page {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;\n}\n\n.deploy-header {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  margin-bottom: 30px;\n  padding-bottom: 20px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.header-info h1 {\n  margin: 0;\n  font-size: 2rem;\n  font-weight: 600;\n  color: #1a1a1a;\n}\n\n.project-title {\n  margin: 5px 0 0 0;\n  color: #666;\n  font-size: 1rem;\n}\n\n.back-button {\n  background: none;\n  border: 1px solid #ddd;\n  padding: 8px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  color: #555;\n  transition: all 0.2s ease;\n}\n\n.back-button:hover {\n  background-color: #f5f5f5;\n  border-color: #bbb;\n}\n\n.deploy-button {\n  background-color: #28a745;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  margin-left: 10px;\n}\n\n.deploy-button:hover {\n  background-color: #218838;\n  transform: translateY(-1px);\n}\n\n.loading {\n  text-align: center;\n  padding: 40px;\n  color: #666;\n  font-size: 1.1rem;\n}\n\n.error-message {\n  text-align: center;\n  padding: 40px;\n  color: #dc3545;\n}\n\n.retry-button {\n  background-color: #007bff;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-top: 10px;\n}\n\n.retry-button:hover {\n  background-color: #0056b3;\n}\n\n.no-videos {\n  text-align: center;\n  padding: 60px 20px;\n  color: #666;\n}\n\n.no-videos-icon {\n  font-size: 4rem;\n  margin-bottom: 20px;\n}\n\n.no-videos h3 {\n  margin: 0 0 15px 0;\n  font-size: 1.5rem;\n  color: #333;\n}\n\n.no-videos p {\n  margin: 5px 0;\n  font-size: 1rem;\n}\n\n.videos-list {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.video-row {\n  display: flex;\n  gap: 20px;\n  padding: 20px;\n  border: 1px solid #e0e0e0;\n  border-radius: 12px;\n  background: white;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  align-items: flex-start;\n}\n\n.video-row:hover {\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n  border-color: #d0d0d0;\n}\n\n.video-preview-section {\n  flex: 0 0 320px;\n}\n\n.video-player-container {\n  margin: 10px 0;\n}\n\n.video-player {\n  width: 100%;\n  height: 180px;\n  border-radius: 8px;\n  background: #000;\n}\n\n.video-content-section {\n  flex: 1;\n  min-height: 100px;\n  padding: 0 20px;\n}\n\n.youtube-content h4 {\n  margin: 0 0 15px 0;\n  font-size: 1rem;\n  font-weight: 600;\n  color: #1a1a1a;\n  border-bottom: 1px solid #e0e0e0;\n  padding-bottom: 8px;\n}\n\n.youtube-form .form-group {\n  margin-bottom: 15px;\n}\n\n.youtube-form label {\n  display: block;\n  margin-bottom: 5px;\n  font-size: 0.85rem;\n  font-weight: 500;\n  color: #555;\n}\n\n.youtube-input,\n.youtube-textarea {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  font-family: inherit;\n  transition: border-color 0.2s ease;\n  box-sizing: border-box;\n}\n\n.youtube-input:focus,\n.youtube-textarea:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);\n}\n\n.youtube-textarea {\n  resize: vertical;\n  min-height: 120px;\n}\n\n.youtube-placeholder {\n  text-align: center;\n  padding: 30px 20px;\n  color: #666;\n}\n\n.youtube-placeholder p {\n  margin: 5px 0;\n  font-size: 0.9rem;\n}\n\n.published-video-info {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px;\n  background-color: #f8fff9;\n  border: 1px solid #28a745;\n  border-radius: 6px;\n}\n\n.published-video-link {\n  color: #dc3545;\n  text-decoration: none;\n  font-weight: 500;\n  font-size: 0.9rem;\n}\n\n.published-video-link:hover {\n  text-decoration: underline;\n}\n\n.published-status {\n  color: #28a745;\n  font-size: 0.8rem;\n  font-weight: 500;\n}\n\n.generate-yt-button {\n  background-color: #17a2b8;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.generate-yt-button:hover {\n  background-color: #138496;\n  transform: translateY(-1px);\n}\n\n.generate-yt-button:disabled {\n  background-color: #6c757d;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.refresh-videos-button {\n  background-color: #6f42c1;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.refresh-videos-button:hover {\n  background-color: #5a32a3;\n  transform: translateY(-1px);\n}\n\n.refresh-videos-button:disabled {\n  background-color: #6c757d;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.video-actions {\n  margin-top: 15px;\n  padding-top: 15px;\n  border-top: 1px solid #eee;\n}\n\n.analyze-individual-audio-button {\n  background-color: #28a745;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.analyze-individual-audio-button:hover:not(:disabled) {\n  background-color: #218838;\n  transform: translateY(-1px);\n}\n\n.analyze-individual-audio-button:disabled {\n  background-color: #6c757d;\n  cursor: not-allowed;\n  transform: none;\n  opacity: 0.6;\n}\n\n.loading-spinner {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.audio-quality-section {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  flex-wrap: wrap;\n}\n\n.audio-quality-status {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.quality-indicator {\n  background: none;\n  border: 2px solid;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.quality-indicator:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n}\n\n.quality-good {\n  color: #28a745;\n  border-color: #28a745;\n  background-color: rgba(40, 167, 69, 0.1);\n}\n\n.quality-good:hover {\n  background-color: rgba(40, 167, 69, 0.2);\n}\n\n.quality-fair {\n  color: #ffc107;\n  border-color: #ffc107;\n  background-color: rgba(255, 193, 7, 0.1);\n}\n\n.quality-fair:hover {\n  background-color: rgba(255, 193, 7, 0.2);\n}\n\n.quality-poor {\n  color: #dc3545;\n  border-color: #dc3545;\n  background-color: rgba(220, 53, 69, 0.1);\n}\n\n.quality-poor:hover {\n  background-color: rgba(220, 53, 69, 0.2);\n}\n\n.quality-error {\n  color: #6c757d;\n  border-color: #6c757d;\n  background-color: rgba(108, 117, 125, 0.1);\n}\n\n.quality-error:hover {\n  background-color: rgba(108, 117, 125, 0.2);\n}\n\n.quality-date {\n  font-size: 11px;\n  color: #666;\n  font-style: italic;\n}\n\n.youtube-content-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n}\n\n.youtube-content-header h4 {\n  margin: 0;\n}\n\n.publish-toggle-container {\n  display: flex;\n  align-items: center;\n}\n\n.publish-toggle {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  user-select: none;\n}\n\n.toggle-checkbox {\n  display: none;\n}\n\n.toggle-slider {\n  position: relative;\n  width: 50px;\n  height: 24px;\n  background-color: #ccc;\n  border-radius: 12px;\n  transition: background-color 0.3s ease;\n}\n\n.toggle-slider:before {\n  content: \"\";\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 20px;\n  height: 20px;\n  background-color: white;\n  border-radius: 50%;\n  transition: transform 0.3s ease;\n}\n\n.toggle-checkbox:checked + .toggle-slider {\n  background-color: #28a745;\n}\n\n.toggle-checkbox:checked + .toggle-slider:before {\n  transform: translateX(26px);\n}\n\n.toggle-label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #333;\n}\n\n.toggle-checkbox:checked ~ .toggle-label {\n  color: #28a745;\n}\n\n.header-buttons {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.prepare-deploy-button {\n  background-color: #ffc107;\n  color: #212529;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.prepare-deploy-button:hover {\n  background-color: #e0a800;\n  transform: translateY(-1px);\n}\n\n.prepare-deploy-button:disabled {\n  background-color: #6c757d;\n  color: white;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.publish-button {\n  background-color: #28a745;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.publish-button:hover {\n  background-color: #218838;\n  transform: translateY(-1px);\n}\n\n.publish-button:disabled {\n  background-color: #6c757d;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.thumbnail-upload {\n  margin-bottom: 20px;\n  padding: 15px;\n  border: 2px dashed #ddd;\n  border-radius: 8px;\n  background-color: #f8f9fa;\n}\n\n.thumbnail-upload label {\n  display: block;\n  margin-bottom: 8px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: #333;\n}\n\n.thumbnail-input {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 0.9rem;\n  background-color: white;\n}\n\n.thumbnail-preview {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-top: 10px;\n  padding: 10px;\n  background-color: white;\n  border-radius: 6px;\n  border: 1px solid #e0e0e0;\n}\n\n.thumbnail-image {\n  width: 80px;\n  height: 45px;\n  object-fit: cover;\n  border-radius: 4px;\n  border: 1px solid #ddd;\n}\n\n.thumbnail-status {\n  color: #28a745;\n  font-size: 0.85rem;\n  font-weight: 500;\n}\n\n/* Deployment Results Styles */\n.deployment-results {\n  margin: 20px 0;\n  padding: 20px;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  background-color: #f8f9fa;\n}\n\n.results-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.results-header h3 {\n  margin: 0;\n  color: #333;\n  font-size: 1.1rem;\n}\n\n.results-summary {\n  display: flex;\n  gap: 15px;\n}\n\n.success-count {\n  color: #28a745;\n  font-weight: 500;\n  font-size: 0.9rem;\n}\n\n.error-count {\n  color: #dc3545;\n  font-weight: 500;\n  font-size: 0.9rem;\n}\n\n.success-message {\n  text-align: center;\n  padding: 20px;\n  color: #28a745;\n  font-size: 1.1rem;\n  font-weight: 500;\n}\n\n.results-details {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.result-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 15px;\n  border-radius: 6px;\n  background-color: white;\n  border: 1px solid #e0e0e0;\n}\n\n.result-item.success {\n  border-left: 4px solid #28a745;\n  background-color: #f8fff9;\n}\n\n.result-item.failed {\n  border-left: 4px solid #dc3545;\n  background-color: #fff8f8;\n}\n\n.result-language {\n  font-weight: 500;\n  color: #333;\n}\n\n.result-status .success {\n  color: #28a745;\n  font-weight: 500;\n}\n\n.result-status .failed {\n  color: #dc3545;\n  font-weight: 500;\n}\n\n.video-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.video-id {\n  font-size: 0.8rem;\n  color: #666;\n  font-family: monospace;\n}\n\n.video-link {\n  font-size: 0.8rem;\n  color: #007bff;\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.video-link:hover {\n  text-decoration: underline;\n}\n\n/* Deployment Errors Styles */\n.deployment-errors {\n  margin: 20px 0;\n  padding: 20px;\n  border: 2px solid #dc3545;\n  border-radius: 8px;\n  background-color: #fff5f5;\n}\n\n.error-header {\n  margin-bottom: 15px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #f5c6cb;\n}\n\n.error-header h3 {\n  margin: 0;\n  color: #721c24;\n  font-size: 1.1rem;\n}\n\n.error-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 15px;\n}\n\n.error-item {\n  padding: 12px 15px;\n  border-radius: 6px;\n  background-color: white;\n  border: 1px solid #f5c6cb;\n  border-left: 4px solid #dc3545;\n}\n\n.error-language {\n  font-weight: 500;\n  color: #721c24;\n  margin-bottom: 5px;\n}\n\n.error-message {\n  color: #856404;\n  font-size: 0.9rem;\n  line-height: 1.4;\n  background-color: #fff3cd;\n  padding: 8px 10px;\n  border-radius: 4px;\n  border: 1px solid #ffeaa7;\n}\n\n.error-actions {\n  text-align: right;\n}\n\n.dismiss-errors-btn {\n  background-color: #6c757d;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: background-color 0.2s ease;\n}\n\n.dismiss-errors-btn:hover {\n  background-color: #5a6268;\n}\n\n/* Modal Styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal {\n  background: white;\n  border-radius: 12px;\n  width: 90%;\n  max-width: 500px;\n  max-height: 90vh;\n  overflow: hidden;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.modal-header h3 {\n  margin: 0;\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: #1a1a1a;\n}\n\n.modal-close {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #666;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: background-color 0.2s ease;\n}\n\n.modal-close:hover {\n  background-color: #f5f5f5;\n}\n\n.modal-content {\n  padding: 20px;\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.modal-content .form-group {\n  margin-bottom: 20px;\n}\n\n.modal-content label {\n  display: block;\n  margin-bottom: 8px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: #333;\n}\n\n.modal-content input,\n.modal-content textarea {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  font-family: inherit;\n  transition: border-color 0.2s ease;\n  box-sizing: border-box;\n}\n\n.modal-content input:focus,\n.modal-content textarea:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 20px;\n  border-top: 1px solid #e0e0e0;\n}\n\n.modal-cancel,\n.modal-save {\n  padding: 10px 20px;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.modal-cancel {\n  background: none;\n  border: 1px solid #ddd;\n  color: #555;\n}\n\n.modal-cancel:hover {\n  background-color: #f5f5f5;\n}\n\n.modal-save {\n  background-color: #28a745;\n  border: none;\n  color: white;\n}\n\n.modal-save:hover {\n  background-color: #218838;\n}\n\n.modal-save:disabled {\n  background-color: #6c757d;\n  cursor: not-allowed;\n}\n\n.language-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 0;\n  text-align: left;\n}\n\n.language-header h3 {\n  margin: 0;\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #1a1a1a;\n}\n\n.language-code {\n  font-size: 0.8rem;\n  color: #666;\n  background: #f8f9fa;\n  padding: 2px 6px;\n  border-radius: 4px;\n}\n\n.video-metadata-compact {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  margin-top: 8px;\n  padding: 6px 8px;\n  background: #f8f9fa;\n  border-radius: 6px;\n  flex-wrap: wrap;\n}\n\n.video-metadata-compact .metadata-item {\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  font-size: 0.75rem;\n  color: #555;\n  font-weight: 500;\n}\n\n\n.deploy-footer {\n  text-align: center;\n  margin-top: 40px;\n  padding-top: 20px;\n  border-top: 1px solid #e0e0e0;\n}\n\n.stats {\n  color: #666;\n  font-size: 0.9rem;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .deploy-page {\n    padding: 15px;\n  }\n  \n  .video-row {\n    flex-direction: column;\n    gap: 15px;\n  }\n  \n  .video-preview-section {\n    flex: none;\n    max-width: 100%;\n  }\n  \n  .video-player {\n    height: 200px;\n  }\n  \n  .language-header h3 {\n    font-size: 1rem;\n  }\n  \n  .video-metadata-compact {\n    justify-content: center;\n    gap: 12px;\n  }\n  \n  .deploy-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n  \n  .header-info h1 {\n    font-size: 1.5rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .video-preview-section {\n    flex: none;\n  }\n  \n  .video-player {\n    height: 180px;\n  }\n  \n  .language-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n  }\n  \n  .video-metadata-compact {\n    flex-direction: column;\n    gap: 6px;\n    align-items: flex-start;\n  }\n  \n  .video-metadata-compact .metadata-item {\n    font-size: 0.7rem;\n  }\n}\n\n/* Audio Analysis Styles */\n.analyze-audio-button {\n  background-color: #6f42c1;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.analyze-audio-button:hover:not(:disabled) {\n  background-color: #5a359a;\n  transform: translateY(-1px);\n}\n\n.analyze-audio-button:disabled {\n  background-color: #9c88c4;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.audio-analysis-overlay {\n  position: relative;\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n  border: 2px solid #6f42c1;\n  border-radius: 12px;\n  padding: 20px;\n  margin-bottom: 20px;\n  box-shadow: 0 4px 12px rgba(111, 66, 193, 0.15);\n}\n\n.audio-analysis-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #dee2e6;\n}\n\n.audio-analysis-header h4 {\n  margin: 0;\n  color: #6f42c1;\n  font-size: 1.1rem;\n  font-weight: 600;\n}\n\n.close-analysis-btn {\n  background: none;\n  border: none;\n  font-size: 24px;\n  color: #6c757d;\n  cursor: pointer;\n  padding: 0;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: all 0.2s ease;\n}\n\n.close-analysis-btn:hover {\n  background-color: #e9ecef;\n  color: #495057;\n}\n\n.audio-analysis-content {\n  space: 16px 0;\n}\n\n.overall-status {\n  margin-bottom: 16px;\n}\n\n.status-indicator {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  border-radius: 20px;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.status-indicator.good {\n  background-color: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n}\n\n.status-indicator.fair {\n  background-color: #fff3cd;\n  color: #856404;\n  border: 1px solid #ffeaa7;\n}\n\n.status-indicator.poor {\n  background-color: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n}\n\n.status-indicator.error,\n.status-indicator.unknown {\n  background-color: #e2e3e5;\n  color: #41464b;\n  border: 1px solid #d6d8db;\n}\n\n.analysis-summary {\n  margin-bottom: 16px;\n  padding: 12px;\n  background-color: #ffffff;\n  border-radius: 8px;\n  border-left: 4px solid #6f42c1;\n}\n\n.analysis-summary strong {\n  color: #6f42c1;\n  display: block;\n  margin-bottom: 8px;\n}\n\n.analysis-summary p {\n  margin: 0;\n  color: #495057;\n  line-height: 1.5;\n}\n\n.audio-issues {\n  margin-bottom: 16px;\n}\n\n.audio-issues strong {\n  color: #dc3545;\n  display: block;\n  margin-bottom: 12px;\n  font-size: 16px;\n}\n\n.audio-issues ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.issue-item {\n  background-color: #ffffff;\n  border: 1px solid #f8d7da;\n  border-radius: 8px;\n  padding: 12px;\n  margin-bottom: 8px;\n  border-left: 4px solid #dc3545;\n}\n\n.issue-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.issue-type-badge {\n  font-weight: 600;\n  color: #721c24;\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  background-color: #f8d7da;\n  padding: 4px 8px;\n  border-radius: 4px;\n  border: 1px solid #f5c6cb;\n}\n\n.issue-timestamp-precise {\n  background-color: #495057;\n  color: white;\n  padding: 4px 10px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-family: 'SF Mono', 'Monaco', 'Menlo', monospace;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-weight: 500;\n}\n\n.timestamp-seconds {\n  font-size: 11px;\n  opacity: 0.8;\n  font-weight: 400;\n}\n\n.timeline-item-info {\n  font-size: 10px;\n  background-color: rgba(255, 255, 255, 0.2);\n  padding: 2px 6px;\n  border-radius: 3px;\n  margin-left: 4px;\n}\n\n.issue-type {\n  font-weight: 600;\n  color: #721c24;\n  font-size: 14px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 4px;\n}\n\n.issue-timestamp {\n  background-color: #495057;\n  color: white;\n  padding: 2px 8px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-family: monospace;\n  display: inline-block;\n  margin-bottom: 8px;\n}\n\n/* Save YouTube Details Button */\n.save-youtube-btn {\n  background: linear-gradient(135deg, #28a745, #20c997);\n  color: white;\n  border: none;\n  padding: 10px 16px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  width: 100%;\n  margin-top: 8px;\n}\n\n.save-youtube-btn:hover {\n  background: linear-gradient(135deg, #218838, #1ea080);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(40, 167, 69, 0.3);\n}\n\n.save-youtube-btn:active {\n  transform: translateY(0);\n}\n\n.save-youtube-btn:disabled {\n  background: #6c757d;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n/* YouTube Actions Container */\n.youtube-actions {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n/* Remove YouTube Details Button */\n.remove-youtube-btn {\n  background: linear-gradient(135deg, #dc3545, #c82333);\n  color: white;\n  border: none;\n  padding: 10px 16px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 4px rgba(220, 53, 69, 0.2);\n}\n\n.remove-youtube-btn:hover {\n  background: linear-gradient(135deg, #c82333, #bd2130);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(220, 53, 69, 0.3);\n}\n\n.remove-youtube-btn:active {\n  transform: translateY(0);\n}\n\n.remove-youtube-btn:disabled {\n  background: #6c757d;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.analysis-info {\n  margin-top: 12px;\n  padding: 8px 12px;\n  background-color: #f8f9fa;\n  border-radius: 4px;\n  border: 1px solid #dee2e6;\n}\n\n.analysis-info small {\n  color: #6c757d;\n  font-size: 12px;\n}\n\n.quality-breakdown {\n  margin-top: 6px;\n  padding-top: 6px;\n  border-top: 1px solid #e9ecef;\n  font-size: 11px;\n}\n\n.detailed-analysis {\n  margin-top: 16px;\n  padding: 16px;\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  border: 1px solid #e9ecef;\n}\n\n.detailed-analysis strong {\n  display: block;\n  margin-bottom: 12px;\n  color: #495057;\n  font-size: 14px;\n}\n\n.detailed-analysis-grid {\n  display: grid;\n  gap: 12px;\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.clip-analysis-item {\n  background: white;\n  padding: 12px;\n  border-radius: 6px;\n  border: 1px solid #dee2e6;\n}\n\n.clip-analysis-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.clip-id {\n  font-weight: 600;\n  color: #495057;\n  font-size: 13px;\n}\n\n.clip-quality {\n  padding: 3px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.clip-quality.good {\n  background-color: #d4edda;\n  color: #155724;\n}\n\n.clip-quality.fair {\n  background-color: #fff3cd;\n  color: #856404;\n}\n\n.clip-quality.poor {\n  background-color: #f8d7da;\n  color: #721c24;\n}\n\n.clip-quality.error {\n  background-color: #f5c6cb;\n  color: #721c24;\n}\n\n.clip-details {\n  font-size: 12px;\n  color: #6c757d;\n}\n\n.narration-preview {\n  font-style: italic;\n  margin-bottom: 6px;\n  color: #495057;\n}\n\n.clip-issue {\n  color: #dc3545;\n  font-weight: 500;\n  margin-bottom: 6px;\n}\n\n.clip-meta {\n  font-size: 11px;\n  color: #6c757d;\n}\n\n.text-mismatch {\n  color: #856404;\n  font-weight: 500;\n}\n\n.more-clips-notice {\n  text-align: center;\n  color: #6c757d;\n  font-style: italic;\n  padding: 12px;\n  background-color: #e9ecef;\n  border-radius: 4px;\n}\n\n.issue-description {\n  color: #495057;\n  line-height: 1.4;\n  font-size: 14px;\n}\n\n.audio-recommendations {\n  background-color: #ffffff;\n  border-radius: 8px;\n  padding: 16px;\n  border-left: 4px solid #28a745;\n}\n\n.audio-recommendations strong {\n  color: #28a745;\n  display: block;\n  margin-bottom: 12px;\n  font-size: 16px;\n}\n\n.audio-recommendations ul {\n  margin: 0;\n  padding-left: 20px;\n}\n\n.audio-recommendations li {\n  color: #495057;\n  line-height: 1.5;\n  margin-bottom: 6px;\n}\n\n@media (max-width: 768px) {\n  .audio-analysis-overlay {\n    margin: 10px 0;\n    padding: 16px;\n  }\n  \n  .audio-analysis-header h4 {\n    font-size: 1rem;\n  }\n  \n  .issue-item {\n    padding: 10px;\n  }\n}\n\n/* Audio Analysis Loader */\n.audio-analysis-loader-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n.audio-analysis-loader {\n  background: white;\n  border-radius: 16px;\n  padding: 40px;\n  text-align: center;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  max-width: 400px;\n  width: 90%;\n}\n\n.loader-spinner {\n  width: 60px;\n  height: 60px;\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #6f42c1;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin: 0 auto 20px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.audio-analysis-loader h3 {\n  margin: 0 0 16px 0;\n  color: #6f42c1;\n  font-size: 1.2rem;\n  font-weight: 600;\n}\n\n.audio-analysis-loader p {\n  margin: 8px 0 0 0;\n  color: #666;\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n/* Comprehensive Analysis Styles */\n.comprehensive-analysis {\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n  border: 2px solid #6f42c1;\n  border-radius: 12px;\n  padding: 24px;\n  margin: 20px 0;\n  box-shadow: 0 6px 16px rgba(111, 66, 193, 0.2);\n}\n\n.analysis-details {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.analysis-info-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background-color: #e9ecef;\n  border: 1px solid #ced4da;\n  border-radius: 8px;\n  padding: 8px 12px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #495057;\n  margin-bottom: 16px;\n}\n\n.raw-analysis-content {\n  background-color: #ffffff;\n  border: 1px solid #e9ecef;\n  border-radius: 8px;\n  padding: 20px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;\n  line-height: 1.6;\n  color: #333;\n  max-height: 500px;\n  overflow-y: auto;\n  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.analysis-header {\n  color: #6f42c1;\n  font-weight: 600;\n  font-size: 16px;\n  margin: 16px 0 8px 0;\n  padding-bottom: 4px;\n  border-bottom: 2px solid #e9ecef;\n}\n\n.analysis-header:first-child {\n  margin-top: 0;\n}\n\n.analysis-line {\n  margin: 8px 0;\n  color: #495057;\n  font-size: 14px;\n}\n\n.analysis-line strong {\n  color: #212529;\n  font-weight: 600;\n}\n\n.analysis-line em {\n  color: #6c757d;\n  font-style: italic;\n}\n\n/* YT Generation Progress Overlay */\n.generation-progress-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.generation-progress-modal {\n  background: white;\n  border-radius: 12px;\n  padding: 30px;\n  min-width: 400px;\n  max-width: 500px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n}\n\n.progress-header h3 {\n  margin: 0 0 20px 0;\n  color: #333;\n  text-align: center;\n}\n\n.progress-content {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.progress-step,\n.progress-language {\n  color: #666;\n  font-size: 14px;\n}\n\n.progress-bar {\n  width: 100%;\n  height: 8px;\n  background: #f0f0f0;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.progress-bar-fill {\n  height: 100%;\n  background: linear-gradient(45deg, #007bff, #0056b3);\n  transition: width 0.3s ease;\n  border-radius: 4px;\n}\n\n.progress-text {\n  text-align: center;\n  color: #666;\n  font-size: 14px;\n}\n\n@media (max-width: 768px) {\n  .generation-progress-modal {\n    width: 90%;\n    min-width: unset;\n    padding: 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
